import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cx-brand-color-bar',
  templateUrl: './cx-brand-color-bar.component.html',
  styleUrls: ['./cx-brand-color-bar.component.scss']
})
export class CxBrandColorBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
